<template>
  <div class="selective-child-view">
    <div class="row">
      <div class="col-12 col-md-6">
        <label class="form-label">Sorteer op</label>
        <select
            v-model="orderChildrenBy"
            class="form-select"
        >
          <option :value="'last_name'">Achternaam</option>
          <option :value="'date_of_birth'">Geboortedatum</option>
          <option :value="'full_name'">Volledige naam</option>
          <option :value="'first_name'">Voornaam</option>
        </select>
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label">Volgorde</label>
        <select
            v-model="orderChildrenSort"
            class="form-select"
        >
          <option :value="'desc'">Aflopend</option>
          <option :value="'asc'">Oplopend</option>
        </select>
      </div>
    </div>
    <br>
    <div>
      <child-select
        :all="true"
        :initialSelected="globalChildByIdFilter"
        @onSelect="selectChildren($event)"
        :orderBy="'date_of_birth'"
        :order="'desc'"
        :showDateOfBirth="true"
        :showFilter="false"
        :showSchoolFilter="false"
        :updateChildrenDynamically="false"
        :selectAll="true"
      >
      </child-select>
    </div>
    <br>
      <div class="d-grid">
          <button v-on:click="done()" class="btn btn-info">Sluiten</button>
      </div>
  </div>
</template>

<script>
import ChildSelect from '@/components/Child-Select'
export default {
  name: 'selective-child-view',
  components: {
    ChildSelect
  },
  computed: {
    orderChildrenBy: {
      get () {
        return this.getOrderChildrenBy()
      },
      set (value) {
        this.$store.commit('SET_ORDER_CHILDREN_BY', value)
      }
    },
    orderChildrenSort: {
      get () {
        return this.getOrderChildrenSort()
      },
      set (value) {
        this.$store.commit('SET_ORDER_CHILDREN_SORT', value)
      }
    }
  },
  data () {
    return {
      selectedChildren: []
    }
  },
  methods: {
    selectChildren (children) {
      this.selectedChildren = children
      this.saveFilter()
    },
    saveFilter () {
      var filter = []
      if (this.selectedChildren.length < this.totalChildren) {
        for (var i = 0; i < this.selectedChildren.length; i++) {
          filter.push(this.selectedChildren[i].id)
        }
      }
      this.$store.commit('SET_GLOBAL_CHILD_BY_ID_FILTER', filter)
    },
    done () {
      this.saveFilter()
      this.$store.commit('SET_SHOW_GLOBAL_CHILD_FILTER', false)
      this.closeMainNavbarIfNeeded()
    }
  }
}
</script>

<style scoped>
  .selective-child-view {
    padding-bottom: 100px;
  }
</style>
